import React, { useEffect, useState } from 'react';

import { Button } from '@mui/material';

import { getDate } from '../../utils/functions/Utils';

import './styles.css';

const FormatoValeClienteModal = (props) => {

    const [renderHoja, setRenderHoja] = useState(<></>);
    const [data, setData] = useState({})
    const [refacciones, setRefacciones] = useState([]);
    const [cotizacion, setCotizacion] = useState({});
    const [infoServicio, setInfoServicio] = useState({});
    const [cliente, setCliente] = useState('');
    const [contacto, setContacto] = useState('');
    const [solicitante, setSolicitante] = useState('');
    const [salida, setSalida] = useState({});
    const [userType, setUserType] = useState('');

    // funcion para imprimir el formato
    const printDocument = () => {
        let printContents = document.getElementById('printDiv2').innerHTML;
        localStorage.setItem('printContent', JSON.stringify({ printContents: printContents, name: `Vale de Entrega - ${data.noOrden}` }));
        window.open('/print', '_blank');
    }

    // asigna los valores de la cotizacion a las variables de estado
    useEffect(() => {
        document.body.style.backgroundColor = '#fff';
        setData(props.data);
        setRefacciones(props.productos);
        setCotizacion(props.cotizacion);
        setInfoServicio(props.infoServicio);
        setCliente(props.cliente);
        setContacto(props.contacto);
    }, [props])

    // genera el formato de la cotizacion dependiendo del layout
    const getSuministros = (refacciones, cotizacion) => {
        return (
            <>
                <div style={{ width: '770px', borderRadius: '5px', marginLeft: '23px' }}>
                    <div className='d-flex align-items-stretch' >
                        <p className='mb-0 text-bold d-flex align-items-center justify-content-center text-center' style={{ background: '#c0d8f4ff', color: '#000', fontSize: '10px', width: '60px', border: 'solid black 0.5px', borderTopLeftRadius: '4px' }}>&nbsp;&nbsp;Cantidad </p>
                        <p className='mb-0 text-bold d-flex align-items-center justify-content-center' style={{ background: '#c0d8f4ff', color: '#000', fontSize: '10px', border: 'solid black 0.5px', width: '140px' }}>Item</p>
                        <p className='mb-0 text-bold d-flex align-items-center justify-content-center' style={{ background: '#c0d8f4ff', color: '#000', fontSize: '10px', border: 'solid black 0.5px', width: '570px', borderTopRightRadius: '4px' }}>Descripción</p>
                    </div>
                    <div>
                        {
                            refacciones.map(r => {
                                if (!['S001', 'S008'].some(s => r.clave.includes(s))) {
                                    return (
                                        <div className='d-flex' key={`${r.id}Ticket`}>
                                            <p className='mb-0 d-flex align-items-center justify-content-center' style={{ color: '#000', fontSize: '10px', width: '60px', border: 'solid black 0.5px' }}>&nbsp;&nbsp;{r.cantidad}</p>
                                            <div style={{ border: 'solid black 0.5px', width: '140px' }} className='d-flex flex-column align-items-center justify-content-center'>
                                                <p className='mb-0 px-1' style={{ color: '#000', fontSize: '10px' }}>{r.clave}</p>
                                            </div>
                                            <p className='mb-0 d-flex align-items-center justify-content-center text-center' style={{ color: '#000', fontSize: '10px', border: 'solid black 0.5px', width: '570px' }}>{r.descripcion}</p>
                                        </div>
                                    )
                                } else {
                                    return null
                                }
                            })}
                    </div>
                </div>

                <hr className='my-2' style={{ color: '#555999' }}></hr>
                <div className='justify-content-center' style={{ zIndex: '1', marginLeft: '23px' }}>
                    <div className='d-flex flex-row'>

                        <div style={{ marginLeft: '0px', color: '#000' }}>
                            <div style={{ display: 'flex' }}>
                                <div style={{ marginLeft: '24px' }}>
                                    <p style={{ fontSize: '8px', marginBottom: '4px' }}>Recibe:</p>
                                    <div style={{ display: 'flex', justifyContent: 'center', height: '20px' }}></div>
                                    <p className='mb-0 text-center' style={{ fontSize: '8px' }}>___________________________</p>
                                    <p className='mb-0 text-center text-bold' style={{ fontSize: '8px' }}>{props.cliente.name}</p>
                                    <p className='mb-0 text-center' style={{ fontSize: '8px' }}>{props.contacto}</p>
                                </div>
                            </div>
                        </div>

                        <div style={{ marginLeft: '300px', marginTop: '24px', color: '#000', width: '300px' }}>
                            <div style={{ display: 'flex' }}>
                                <p style={{ fontSize: '8px', marginBottom: '4px' }}>{data.observacionVale}</p>
                            </div>
                        </div>
                    </div>
                </div>
            </>
        )
    }

    useEffect(() => {
        if (props.productos && props.cotizacion) {
            setRenderHoja(
                <div id='printDiv2' style={{ position: 'relative', width: '816px', height: '1056px', background: '#FFF', zIndex: '1', transformOrigin: '0 0', transform: 'scale(1.4)' }} className='p-0' contentEditable="true" suppressContentEditableWarning={true}>
                    <img src={`/${props.company}/vale-cliente-bg.svg`} alt='bg-design' style={{ position: 'absolute', width: '100%', height: '100%', objectFit: 'cover', zIndex: '-2' }} />
                    <div style={{ height: '60px' }}>
                    </div>

                    <div style={{ height: '468px' }}>

                        <div style={{ width: '715px !important', maxHeight: '30px', display: 'flex', flexDirection: 'column', flexWrap: 'wrap', marginLeft: '23px' }}>
                            <div className='d-flex align-items-stretch' style={{ width: '354px', color: '#000' }}>
                                <p style={{ width: '100px', fontSize: '9px' }} className='mb-0 px-1 text-bold d-flex align-items-center'>Vendedor: </p>
                                <p style={{ width: '280px', fontSize: '9px', textOverflow: 'ellipsis', whiteSpace: 'nowrap', overflow: 'hidden' }} className='mb-0 px-1'>{data.vendedor}</p>
                            </div>
                            <div className='d-flex align-items-stretch' style={{ width: '354px', color: '#000' }}>
                                <p style={{ width: '100px', fontSize: '9px' }} className='mb-0 px-1 text-bold d-flex align-items-center'>Fecha de entrega: </p>
                                <p style={{ width: '280px', fontSize: '9px' }} className='mb-0 px-1'>{data.fechaDeEntrega ? getDate(data.fechaDeEntrega, 'DDDD').toUpperCase() : ''}</p>
                            </div>
                            <div className='d-flex align-items-stretch' style={{ width: '354px', color: '#000' }}>
                                <p style={{ width: '100px', fontSize: '9px' }} className='mb-0 px-1 text-bold d-flex align-items-center'># Cotización: </p>
                                <p style={{ width: '280px', fontSize: '9px', textOverflow: 'ellipsis', whiteSpace: 'nowrap', overflow: 'hidden' }} className='mb-0 px-1'>{data.noOrden}</p>
                            </div>
                        </div>

                        <hr className='my-1' style={{ color: '#555999' }} />

                        <div style={{ marginTop: '12px' }}>
                            {getSuministros(refacciones, cotizacion)}
                        </div>
                    </div>

                    <div style={{ height: '528px' }}>
                        <div style={{ height: '60px' }}></div>

                        <div style={{ width: '715px !important', maxHeight: '30px', display: 'flex', flexDirection: 'column', flexWrap: 'wrap', marginLeft: '23px' }}>
                            <div className='d-flex align-items-stretch' style={{ width: '354px', color: '#000' }}>
                                <p style={{ width: '100px', fontSize: '9px' }} className='mb-0 px-1 text-bold d-flex align-items-center'>Vendedor: </p>
                                <p style={{ width: '280px', fontSize: '9px', textOverflow: 'ellipsis', whiteSpace: 'nowrap', overflow: 'hidden' }} className='mb-0 px-1'>{data.vendedor === 'NIDIA VAZQUEZ' ? 'MARIEL CALVILLO' : data.vendedor}</p>
                            </div>
                            <div className='d-flex align-items-stretch' style={{ width: '354px', color: '#000' }}>
                                <p style={{ width: '100px', fontSize: '9px' }} className='mb-0 px-1 text-bold d-flex align-items-center'>Fecha de entrega: </p>
                                <p style={{ width: '280px', fontSize: '9px' }} className='mb-0 px-1'>{data.fechaDeEntrega ? getDate(data.fechaDeEntrega, 'DDDD').toUpperCase() : ''}</p>
                            </div>
                            <div className='d-flex align-items-stretch' style={{ width: '354px', color: '#000' }}>
                                <p style={{ width: '100px', fontSize: '9px' }} className='mb-0 px-1 text-bold d-flex align-items-center'># Cotización: </p>
                                <p style={{ width: '280px', fontSize: '9px', textOverflow: 'ellipsis', whiteSpace: 'nowrap', overflow: 'hidden' }} className='mb-0 px-1'>{data.noOrden}</p>
                            </div>
                        </div>

                        <hr className='my-1' style={{ color: '#555999' }} />

                        <div style={{ marginTop: '12px' }}>
                            {getSuministros(refacciones, cotizacion)}
                        </div>
                    </div>
                </div>
            )
        }
    }, [data, refacciones, cotizacion, props])

    return (
        <div>
            <div style={{ marginTop: '10px', marginBottom: '12px' }}>
                <Button className='mx-2' variant='contained' color='secondary' onClick={printDocument}>Imprimir hoja &nbsp; <i className="fad fa-print" style={{ transform: 'scale(1.3)' }}></i></Button>
            </div>
            {renderHoja}
        </div>
    )
}

export default FormatoValeClienteModal;